/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (locations) => ({
    type: actions.CONNECTION_LOCATIONS_RECEIVE,
    payload: { locations },
});